import { isUrl } from '../../../validators';
import type {
    CommonAttributeSettings,
    PropDescriptor
} from '../common';
import {
    DEFAULT_ATTRIBUTE_SETTINGS,
    defineMetadata
} from '../common';

import {
    createTemplateGetter,
    createTemplateSetter,
    createThemeRef,
    isTemplateReference,
    ThemeRefTypes
} from './common';

export const FONT_ATTRIBUTE_TYPE = 'fontAttributeType';

function fontValueValidator(value: any) {
    if (isTemplateReference(value)) {
        if (!value.includes(ThemeRefTypes.FONTS)) {
            throw Error(`Invalid value for font theme ref: ${value}`);
        }
    }
    else if (!isUrl(value)) {
        throw Error(`Invalid font value: ${value}`);
    }
}

export function templateFontsByIndex(index: number): string {
    return createThemeRef(ThemeRefTypes.FONTS, index);
}

/**
 * Creates an attribute decorator used to describe a font property. This will enforce either a valid url
 * value or a theme reference string such as themeRef_font_0.
 * @param settings
 */
export function FontAttribute(settings: Partial<CommonAttributeSettings> = {}) {
    settings = { ...DEFAULT_ATTRIBUTE_SETTINGS, ...settings };
    return function(target: object, propertyKey: string, descriptor: PropDescriptor) {
        const initialValue = descriptor.initializer();
        const isInitialValueOverridden = new WeakMap();

        defineMetadata(target, propertyKey, settings, FONT_ATTRIBUTE_TYPE);

        return {
            configurable: true,
            enumerable: true,
            get: createTemplateGetter(propertyKey, initialValue, ThemeRefTypes.FONTS),
            set: createTemplateSetter(propertyKey, initialValue, fontValueValidator, isInitialValueOverridden, ThemeRefTypes.FONTS),
        };
    } as any;
}
